import Composedchart from './Composedchart';

export default Composedchart;
